import React, { useEffect, useState } from "react";
import {
  Typography,
  Card,
  CardContent,
  Box,
  IconButton,
  Stack,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import TextContainerField from "../../../components/TextContainerField";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate, useParams } from "react-router-dom";
import { fetchDataById } from "../../../api/Services";
import Spinner from "../../../components/Spinner";

const ViewMotorKeyValue = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [keyValueData, setKeyValueData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const paramId = params.id;

      if (paramId) {
        setIsLoading(true);
        try {
          await fetchDataById(
            `/reference/motor/key-value-store/${paramId}`
          ).then((res) => {
            console.log(res);
            setKeyValueData((prevData) => ({
              ...prevData,
              ...res?.data,
            }));
          });
        } catch (err) {
          console.log(err);
        } finally {
          setIsLoading(false);
        }
      }
    };

    fetchData();
  }, [params.id]);

  if (isLoading) {
    return (
      <DashboardLayout>
        <Spinner />
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <Box
        sx={{
          padding: { xs: 2, md: 2 },
          bgcolor: "#f9f9f9",
          minHeight: "100vh",
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="left"
          spacing={1}
          mb={2}
        >
          <IconButton onClick={() => navigate("/motor-master/motor-keyValue")}>
            <ArrowBack />
          </IconButton>
          <Typography variant="h4" gutterBottom sx={{ fontWeight: "bold" }}>
            Motor Key Value Information
          </Typography>
        </Stack>

        {keyValueData ? (
          <Grid container spacing={3} sx={{ mx: { xs: 0, md: 2 } }}>
            <Grid xs={12} sm={6} md={4} sx={{ width: "100%" }}>
              <Card sx={{ boxShadow: 3, borderRadius: 2, bgcolor: "white" }}>
                <CardContent>
                  <Typography variant="h6" sx={{ mb: 1, fontWeight: "600" }}>
                    {keyValueData?.categoryName}
                  </Typography>
                  <TextContainerField
                    label="Key Value ID"
                    value={keyValueData?.id}
                    labelStyle={{ fontWeight: "500" }}
                  />
                  <TextContainerField
                    label="Key Name"
                    value={keyValueData?.keyName}
                    labelStyle={{ fontWeight: "500" }}
                  />
                  <TextContainerField
                    label="Category Name"
                    value={keyValueData?.category?.name}
                    labelStyle={{ fontWeight: "500" }}
                  />
                  <TextContainerField
                    label="Status"
                    value={keyValueData?.isActive ? "Active" : "Inactive"}
                    labelStyle={{ fontWeight: "500" }}
                  />
                  {/* <TextContainerField label="Created By" value={keyValueData?.createdBy} labelStyle={{ fontWeight: "500" }} /> */}
                  <TextContainerField
                    label="Created At"
                    value={
                      keyValueData?.createdAt
                        ? new Date(keyValueData.createdAt)
                            .toLocaleString("en-GB")
                            .replace(",", "")
                        : "-"
                    }
                    labelStyle={{ fontWeight: "500" }}
                  />
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        ) : (
          <Box>
            <Typography
              variant="h4"
              gutterBottom
              sx={{
                textAlign: "center",
                fontWeight: "bold",
                color: "red",
                fontFamily: "cursive",
              }}
            >
              No Motor Key Value Data Found
            </Typography>
          </Box>
        )}
      </Box>
    </DashboardLayout>
  );
};

export default ViewMotorKeyValue;
